import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CompanyService } from '../services/company.service';
import { Company } from '../models/Company';
import { PermissionsComponent } from './permission-component/permissions.component';
import { OptionsComponent } from './options-component/options.component';
import { LegalRepresentative } from '../../account/models/LegalRepresentative';
import { InlineEditComponent } from './inline-edit/inline-edit.component';
import { debounceTime } from 'rxjs/operators';
import { map, switchMap } from 'rxjs/internal/operators';
import { of, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-legal-representatives',
  templateUrl: './legal-representatives.component.html',
  styleUrls: ['./legal-representatives.component.scss']
})
export class LegalRepresentativesComponent implements OnInit, OnDestroy {
  public settings = {
    actions: 'false',
    hideSubHeader: true,
    columns: {
      email: {
        title: 'Email',
        type: 'custom',
        renderComponent: InlineEditComponent,
        onComponentInitFunction: (instance) => {
          instance.valueEmitter
            .pipe(debounceTime(200))
            .subscribe(value => {
              const representative = this.legalRepresentatives.find(e => e.isDraft === true);

              if (representative) {
                representative.email = value;
              }
            });
        },
        valuePrepareFunction: (rowData, cell, value) => {
          return {
            type: 'email',
            data: rowData,
            cell
          };
        }
      },
      lastName: {
        title: 'Nume'
      },
      firstName: {
        title: 'Prenume'
      },
      cnp: {
        title: 'CNP'
      },
      roluri: {
        title: 'Roluri',
        type: 'custom',
        renderComponent: PermissionsComponent,
        onComponentInitFunction: (instance: PermissionsComponent) => {
          instance.canModifyContract.subscribe(row => {
            const representative = this.findLegalRepresentative(row);
            console.log(row, '===', representative);
            representative.canChangeSupplierContract = row.canChangeSupplierContract;
          });
          instance.canViewInformation.subscribe(row => {
            const representative = this.findLegalRepresentative(row);
            console.log(row, '===', representative);
            representative.canViewInformation = row.canViewInformation;
          });
          instance.canEditCompany.subscribe(row => {
            const representative = this.findLegalRepresentative(row);
            console.log(row, '===', representative);
            representative.canEditInformation = row.canEditInformation;
          });
        }
      },
      status: {
        title: 'Status'
      },
      optiuni: {
        title: 'Optiuni',
        type: 'custom',
        renderComponent: OptionsComponent,
        valuePrepareFunction: (rowData, cell, value) => {
          return {
            companyCode: this.companyCode,
            data: rowData,
            cell
          };
        },
        onComponentInitFunction: (instance: OptionsComponent) => {
          instance.inactivate.subscribe(row => {
            this.companyDetailsService.removeLegalRepresentative(this.companyCode, row)
              .subscribe(e => {
                this.updateLegalRepresentative(e);
              });
          });
          instance.delete.subscribe(row => {
            this.companyDetailsService.removeLegalRepresentative(this.companyCode, row)
              .subscribe(e => {
                this.removeLegalRepresentative(e);
              });
          });
          instance.sendInvite.subscribe(row => {
            this.companyDetailsService.addLegalRepresentative(this.companyCode, row).subscribe(e => {
              this.isAddingLegalRepresentative = false;
              this.updateLegalRepresentative(e);
            });
          });
          instance.save.subscribe(row => {
            this.companyDetailsService.updateLegalRepresentativeRoles(this.companyCode, row).subscribe(e => {
              this.updateLegalRepresentative(e);
            });
          });
        },
      },
    }
  };

  public isAddingLegalRepresentative = false;
  public legalRepresentatives = [];
  public companies: Company[] = [];
  public companyCode: string;
  public companyName: string;

  private routeDataSub: Subscription;

  constructor(
    private companyDetailsService: CompanyService,
    private changeDetectorRef: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.routeDataSub = this.route
      .paramMap
      .pipe(
        map(value => {
          this.companyCode = window.history.state.companyCode;
          this.companyName = window.history.state.companyName;
          return this.companyCode;
        }),
        switchMap(
          companyCode => companyCode ? this.companyDetailsService.getUserOwnedCompanyLegalRepresentatives(companyCode) : of([])
        )
      ).subscribe((legalRepresentatives) => this.legalRepresentatives = legalRepresentatives);
  }

  findLegalRepresentative(data: any) {
    console.log(data);
    return data.id ?
      this.legalRepresentatives.find(e => e.id === data.id) : this.legalRepresentatives.find(e => e.isDraft === true);
  }

  removeLegalRepresentative(legalRepresentative: LegalRepresentative) {
    const exists = this.legalRepresentatives.some(e => e.id === legalRepresentative.id);
    if (exists) {
      this.legalRepresentatives = this.legalRepresentatives.filter(e => e.id !== legalRepresentative.id);
    } else {
      this.legalRepresentatives = this.legalRepresentatives.filter(e => e.isDraft !== true);
    }
  }

  updateLegalRepresentative(legalRepresentative: LegalRepresentative) {
    const exists = this.legalRepresentatives.some(e => e.id === legalRepresentative.id);
    if (exists) {
      this.legalRepresentatives = this.legalRepresentatives.map(e => e.id !== legalRepresentative.id ? e : legalRepresentative);
    } else {
      this.legalRepresentatives = this.legalRepresentatives.map(e => e.isDraft === true ? legalRepresentative : e);
    }
  }

  addLegalRepresentative() {
    // @ts-ignore
    const reassignedRepresentativesList = [];
    const newEntry = new LegalRepresentative();
    newEntry.isDraft = true;
    newEntry.email = '';
    this.legalRepresentatives.unshift(newEntry);
    reassignedRepresentativesList.push(...this.legalRepresentatives);
    this.legalRepresentatives = reassignedRepresentativesList;

    this.isAddingLegalRepresentative = true;
    this.changeDetectorRef.detectChanges();
  }

  /*onCompanySelect(event: any) {
    const selectedCompany = event.target.value;
    this.companyDetailsService.getUserOwnedCompanyLegalRepresentatives(selectedCompany).subscribe(
      e => {
        this.selectedCompany = selectedCompany;
        this.legalRepresentatives = e;
        this.isAddingLegalRepresentative = false;

        console.log(e);
      }
    );
  }*/

  ngOnDestroy(): void {
    this.routeDataSub.unsubscribe();
  }

}
